import React from 'react';
import './ProductBackButton.css';

/**
 * Uniform floating back control for nested product pages
 * (footer Chat/Apps/Cases is hidden on these routes).
 */
const ProductBackButton = ({
  onClick,
  ariaLabel = 'Back',
  title,
  className = '',
  ...rest
}) => (
  <button
    type="button"
    className={`product-back-btn${className ? ` ${className}` : ''}`}
    onClick={onClick}
    aria-label={ariaLabel}
    title={title || ariaLabel}
    {...rest}
  >
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M15 18L9 12L15 6"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </button>
);

export default ProductBackButton;
